/** The domain name of the Prismic repository. */
export const prismicRepo: string = 'emerald-help';
/** The default language for content in your Prismic repository. */
export const defaultLanguage: string = 'en-us';
/** All alternate languages for content in your Prismic repository. */
export const alternateLanguages: string[] = [ 'es-es'];
